module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e9aeb1d50663c1c105188f39fc6e7e11.png";